<template>
  <ul class="pa-pod-type-selector">
    <template v-for="menu in menus">
      <li :key="menu.slug" :class="menu.class">
        <router-link :to="{ name: 'connections.room', params: { roomType: menu.slug }}"><span>{{menu.label}}</span></router-link>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  data(){
    return {
      menus : {
        public : {
          label : '様々',
          slug  : 'public',
          class : {
            active  : true,
          },
        },
        private : {
          label : 'マイポット',
          slug  : 'private',
          class : {
            active  : false,
          },
        },
      },
    };
  },

  computed : {
    podRoomType(){
      return this.$store.state.connection.podRoomType;
    },

    selectedPodType(){
      return this.$route.params.roomType;
    }
  },

  watch : {
    selectedPodType : {
      handler(value){
        if(typeof value === 'undefined') return;

        this.$store.dispatch({
          type  : 'connection/updatePodRoomType',
          value : value
        });
      },
      immediate: true
    },

    podRoomType : {
      handler(value){
        if(typeof value === 'undefined') return;

        this.setRoomTypeButton();
      },
      immediate: true
    }
  },

  methods : {
    setRoomTypeButton(){
      for(let menu in this.menus){
        this.menus[menu].class.active = false;
      }
      
      this.menus[this.podRoomType].class.active = true;
    }
  },

  mounted(){
    this.setRoomTypeButton();
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-pod-type-selector{
  position: relative;
  // z-index: 100;
  background-color: #C2A78F;
  display: flex;
  flex-direction: row;
  border-bottom:2px solid #C4A988;
  width:100%;

  li{
    box-sizing: border-box;
    width:50%;
    text-align: center;
    font-size:1.3rem;
    padding:.3rem 0;
    border-right: 2px solid #B9A28D;
    color: #7C5E49;

    a{
      display: block;
      width:100%;
      color: #7C5E49;
    }

    .size{
      display: block;

      &-middle{
        font-size:1.1rem;
      }

      &-small{
        margin-top:-.1rem;
        font-size:.55rem;
        line-height: .5rem;
      }
    }

    &.active{
      background-color: #B3957C;

      span{
        box-shadow: inset 0 -3px 0 0 #7C5E49;
      }
    }

    &.is-disable{
      background-color: #BBA490;
      color: #A28D7F;
    }
  }

  li:last-child{
    border-right: 0;
  }
}

@media screen and (min-width: $desktop) {
  .pa-pod-selector{
    margin-top:0;
    li{
      padding:.4rem 0;
    }
  }
}
</style>